/**
 * Time Management for IronHUD (Alpine.js Component)
 */

export const TimeComponent = () => ({
    formatter: null,
    relativeFormatter: null,
    lang: 'pt-BR',

    init() {
        this.lang = document.documentElement.lang || 'pt-BR';
        this.formatter = new Intl.DateTimeFormat(this.lang, {
            weekday: 'long',
            month: 'short',
            day: 'numeric',
        });
        this.relativeFormatter = new Intl.RelativeTimeFormat(this.lang, { numeric: 'auto' });
    },

    formatRelative(timestamp) {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        const now = new Date();
        const diffInDays = Math.round((date - now) / (1000 * 60 * 60 * 24));

        const isPt = this.lang.startsWith('pt');

        if (diffInDays === 0) return isPt ? 'Hoje' : 'Today';
        if (diffInDays === -1) return isPt ? 'Ontem' : 'Yesterday';
        if (Math.abs(diffInDays) < 7) return this.relativeFormatter.format(diffInDays, 'day');

        return date.toLocaleDateString(this.lang, { month: 'short', day: 'numeric' });
    },

    formatFull(timestamp) {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        return this.formatter.format(date);
    },
});
